import { render } from "./Snippets.vue?vue&type=template&id=1be549aa"
import script from "./Snippets.vue?vue&type=script&lang=js"
export * from "./Snippets.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__